import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

export type TypeVerifyAdminCodeParams = {
  /**조퇴 처리 시각 */
  earlyEndAt: string;
  /** 관리자 코드 */
  verificationCode: string;
};

export type TypeVerifyAdminCodeResponse = {
  /** 응답 메시지 */
  message: string;
  code: string;
};

/**
 * @description 조퇴 > 관리자 코드 검증 api 요청에 사용되는 커스텀 훅
 */
export const useVerifyAdminCode = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeVerifyAdminCodeParams) => {
      const endpoint = '/early-end-commutes/verify';
      return axiosInstance.post<TypeVerifyAdminCodeResponse>(endpoint, params);
    },
  });

  const requestVerifyAdminCode = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeVerifyAdminCodeParams;
    onSuccess?: (res: TypeVerifyAdminCodeResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestVerifyAdminCode;
};
